import React from "react";
import AddAdditionalDocumentModal from "features/AdditionalDocuments/AddAdditionalDocumentModal";
import { uploadAssignmentTemplateCustomer } from "./actions";

const AddAssignmentTemplateCustomerModal = ({
  onSubmitted,
  dealerId,
  ...props
}) => (
  <AddAdditionalDocumentModal
    {...props}
    submitAction={uploadAssignmentTemplateCustomer}
    triggerText="Upload New Assignment Template from Customer"
    headerText="New Assignment Template from Customer"
    onSubmitted={onSubmitted}
    dealerId={dealerId}
  />
);

export default AddAssignmentTemplateCustomerModal;
